/**
 * 🔄 Phase B2 (Eliot, 2026-05-04) — Helper "Prochain vs Dernier versement"
 *
 * Détermine le label à afficher dans le widget "Mon Espace" pour les
 * sous-traitants/employés selon l'ÉTAT du rapport hebdomadaire.
 *
 * RÈGLE :
 *   - Rapport envoyé & non payé    → « Votre prochain versement »
 *   - Rapport payé OU pas actif    → « Votre dernier versement »
 *
 * Tant que le rapport de la sem courante n'est PAS envoyé, on reste sur
 * « Dernier versement » (l'utilisateur ne doit pas voir « Prochain » avant
 * que le rapport ne soit produit & envoyé).
 *
 * @example
 *   const label = versementLabel({ rapport_envoye: true, paye: false });
 *   // → "Votre prochain versement"
 */

export function versementLabel(rapport) {
  if (!rapport || typeof rapport !== "object") {
    return "Votre dernier versement";
  }
  const isPaye = !!rapport.paye;
  const isEnvoye = !!(rapport.rapport_envoye || rapport.envoye);
  if (isEnvoye && !isPaye) return "Votre prochain versement";
  return "Votre dernier versement";
}
